import { Button, Col, Row } from 'antd'
import { Variants, motion } from "framer-motion";
import DetailRulePopup from './DetailRulePopup';

type Props = {}

const cardVariants: Variants = {
    offscreen: {
        fontSize: '0rem',
        y: 0,
    },
    onscreen: {
        fontSize: window.innerWidth > 768 ? '3rem' : '2rem',
        y: -100,
        transition: {
            type: 'spring',
            stiffness: 200,
            damping: 20,
        },
    },
};

export default function Rule({ }: Props) {
    return (
        <div
            style={{
                color: 'white',
                width: '100vw',
                marginTop: '30vh',
            }}
        >
            {/* title */}
            <motion.div
                initial="offscreen"
                whileInView="onscreen"
                viewport={{ once: true, amount: 0.8 }}
            >
                <motion.div
                    variants={cardVariants}
                    style={{
                        fontFamily: 'conthrax',
                        textAlign: 'center',
                    }}>
                    <div>QUY CHẾ DỰ THI</div>
                    <div style={{
                        textAlign: 'center',
                    }}>
                        <DetailRulePopup />
                    </div>
                </motion.div>
            </motion.div>
            <div style={{
                fontFamily: 'Readex Pro',
                textAlign: 'center',
                width: window.innerWidth > 768 ? '30vw' : '80vw',
                margin: 'auto',
                fontSize: '.8rem',
                fontWeight: 300,
            }}>
                <p>❖ Mỗi thí sinh tham gia chỉ được đăng ký và nộp DUY NHẤT 1 video dự thi.</p>
                <p>❖ Thời lượng ở mỗi video không được quá 5 PHÚT QUY ĐỊNH.</p>
                <p>❖ Các bài dự thi được nộp về phải là tác phẩm của chính thí sinh và không vi phạm bất cứ luật nào về bản quyền.</p>
                <p>❖ Trong quá trình tham dự, thí sinh phải tuân thủ theo mọi quy định và điều lệ của cuộc thi, cung cấp những thông tin mà Ban Tổ Chức Yêu cầu.</p>
                <p>❖ Nếu thí sinh vi phạm, Ban Tổ Chức có quyền huỷ bỏ quyền dự thi và bài dự thi của thí sinh đó.</p>
                <p>❖ Tất cả các tư liệu liên quan đến cuộc thi của thí sinh sẽ được Ban Tổ Chức toàn quyền sử dụng.</p>
                <p>❖ Các vấn liên quan đến khiếu nại với tư cách là Ban Tổ Chức sẽ có quyền đưa ra thông báo và có quyền quyết định.</p>
            </div>
        </div>
    )
}